/**
 * 9-slice age UI frames (content-schema §2 `uiPrompt`).
 *
 * Each age ships one generated frame sheet (`ui.<age>.frame.png`) authored in
 * exact thirds. CSS `border-image` is the browser's native 9-slice renderer, so
 * the whole mechanism is one declaration (see style.css): `slice 33.34% fill`
 * cuts the 3×3 grid, corners paint 1:1, edge strips tile along their run
 * (`round`), and `fill` paints the centre behind the panel content.
 *
 * The sheet is preloaded here and the `framed` class only flips on once it has
 * actually decoded — dev builds usually lack `/content/` art, and a missing
 * frame must leave the flat panel style untouched rather than strip borders.
 */
export function applyUiFrame(url: string): void {
  const img = new Image();
  img.addEventListener('load', () => {
    document.documentElement.style.setProperty('--ui-frame-src', `url("${url}")`);
    document.body.classList.add('framed');
  });
  img.addEventListener('error', () => {
    document.body.classList.remove('framed');
  });
  img.src = url;
}
